import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the restoration of a library',
  name: 'restore_library',
  params: [
    {
      description: 'The ID of the restored library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the restored library',
      name: 'library_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
